export function Auth0LoginPage() {
  redirectToAuth0();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="text-gray-700">Loading...</p>
    </div>
  );
}

const redirectToAuth0 = () => {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE;
  const redirectUri = `${import.meta.env.VITE_APP_BASE_URL}/auth0-redirect`;

  const params = new URLSearchParams(window.location.search);
  const state = params.get('state') || '';

  // TODO(jacob): Use PKCE
  const authUrl =
    `https://${domain}/authorize?` +
    `response_type=token&` +
    `client_id=${clientId}&` +
    `audience=${encodeURIComponent(audience)}&` +
    `redirect_uri=${encodeURIComponent(redirectUri)}&` +
    `state=${state}`;

  window.location.href = authUrl;
};
